import { AnnouncementImageSize } from '@pya-mms/common';

export const ANNOUNCEMENT_IMAGE_DISPLAY_WIDTH: Record<AnnouncementImageSize, string> = {
  full: '100%',
  md: '60%',
  sm: '33%',
};

export const announcementImageFrameMargin = (size: AnnouncementImageSize): string =>
  size === 'full' ? '12px 0' : '12px auto';
